import { useEffect, useState } from "react"
import { fetchTeamMemberLookup } from "@/lib/entity-api"

export interface CompanyMember {
  id: string
  fullName: string
}

/**
 * Every active person of the company -- Team, Vendor, and Client alike, from
 * the backend's people lookup (GET /api/lookups/team-members), unfiltered by
 * `role` on purpose: "Team Members + Vendors + Clients" is one list, no
 * separate system needed for Gantt's Assignee picker. The id is the person
 * inside the company (what an assignee_id column holds).
 */
export function useCompanyMembers(companyId?: string | null) {
  const [members, setMembers] = useState<CompanyMember[]>([])

  useEffect(() => {
    if (!companyId) {
      setMembers([])
      return
    }
    let cancelled = false
    fetchTeamMemberLookup()
      .then((people) => {
        if (cancelled) return
        const list = people
          .map((p) => ({ id: p.id, fullName: p.full_name || [p.first_name, p.last_name].filter(Boolean).join(" ") || p.email || "Unknown" }))
          .sort((x, y) => x.fullName.localeCompare(y.fullName))
        setMembers(list)
      })
      .catch((error) => {
        if (cancelled) return
        console.error("[useCompanyMembers] failed to load members", error)
        setMembers([])
      })
    return () => {
      cancelled = true
    }
  }, [companyId])

  return members
}
